// extracted by mini-css-extract-plugin
export default {"statusWrap":"status_statusWrap__stttN","table":"status_table__pARrf"};